import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import { Select, MenuItem, Snackbar, Alert } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import React, { Fragment, useEffect, useRef, useState } from "react";
import dateFormat from 'dateformat';
import './return-item.scss';
import { styled } from '@mui/material/styles';
import SimpleDialog from '../controlled-popup/popup';
import { RETURNS_UI_URLS, FILE_UPLOAD } from "../../../constants.js";
import Stepper from '@mui/material/Stepper';
import Step, { stepClasses } from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import infoIcon from "../../../assets/images/icons/info-icon.svg"
import downArrowIcon from "../../../assets/images/icons/down-arrow-icon.svg"
import arrowLeftIcon from "../../../assets/images/icons/icon-arrow-left.svg"
import { useNavigate } from 'react-router-dom';

function ReturnItem({ data, childData, reasonData, HtmlTooltipForAddress, displaySizeandColor }) {
    const containerRef = useRef(null);
    let orderData = data;
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectedReasonData, setSelectedReasonData] = useState([]);
    const [selectedDummyReasonData, setSelectedDummyReasonData] = useState([]);
    const [reasonsResult, setReasonResult] = useState([]);
    const [paymentData, setPaymentData] = useState([]);
    const [shipmentData, setShipmentData] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState([]);
    const [selectedDummyPayment, setSelectedDummyPayment] = useState([]);
    const [selectedShipment, setSelectedShipment] = useState([]);
    const [selectedDummyShipment, setSelectedDummyShipment] = useState([]);
    const [getSubReasonData, setGetSubReasonData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [data1, setRetailerData] = React.useState({});
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [isLoaderEnable, setIsLoaderEnable] = useState(false);
    const [snackbarProp, setSnackbarProp] = useState({});
    const [disableReturnBtn, setDisableReturnBtn] = React.useState(false);
    let retailerInfo = JSON.parse(sessionStorage.getItem('retailerData'));
    const [steps, setSteps] = useState(['Why are you returning this item(s)?', 'How can we make it right?', 'How would you like to return your item(s)?', 'Review and Confirm Returns']);
    const [activeStep, setActiveStep] = useState(0);
    const [skipped] = useState(new Set());
    const [isBackButtonDisable, setIsBackButtonDisable] = useState(false);
    const [arrowButtonEnable, setArrowButtonEnable] = useState(false);
    const [confirmingReturn, setConfirmingReturn] = useState(false);
    const [uploadingImages, setUploadingImages] = useState({});
    const [refundData, setRefundData] = React.useState({});
    let navigate = useNavigate();

    const navigateToMyOrders = (event) => {
        if (JSON.stringify(selectedDummyReasonData) === JSON.stringify(selectedReasonData) && !isBackButtonDisable) {
            childData(isSubmitted);
            event.preventDefault();
        } else {
            openDialog();
        }
    }
    const openDialog = () => {
        setOpen(true);
    };

    const dialogClose = (value) => {
        setOpen(false);
        if (value) {
            childData(isSubmitted);
            sessionStorage.removeItem('selectedDummyReasonData');
            sessionStorage.removeItem('selectedReasonData');
        }
    };
    const navigateToReturned = (value) => {
        childData(value);
    }
  const includeScriptCodeForShowMore = () =>{
        const script = document.createElement('script');
        script.text = `var accs = document.querySelectorAll('[id^="accordionToggle"]');
  accs.forEach((acc) => {
    acc.addEventListener('click', function () {
      var body = this.parentElement.nextElementSibling;
      var isOpen = body.style.display === 'block';
      var icon = this.querySelector('i');

      body.style.display = isOpen ? 'none' : 'block';
      this.innerHTML = isOpen
        ? 'show more <i class="fa-solid fa-chevron-down"></i>'
        : 'show less <i class="fa-solid fa-chevron-up"></i>';
    });
    });`;
    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }

  }
    useEffect(() => {            
        setRetailerData(JSON.parse(sessionStorage.getItem('retailerData')));
        setTimeout(() => {
            scrollToParticularSection('order-wrapper');
        }, 200)
        setReasonResult([]);
        setSelectedReasonData([]);
        const getReasons = async () => {
            setIsLoaderEnable(true);
            try {
                const response = await fetch(RETURNS_UI_URLS.BASE_URL + 'return/' + (JSON.parse(sessionStorage.getItem('RPI'))?.rpi_number) + '/return-attributes', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId)
                    }
                })
                if (!response) {
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                }
                if (response?.status === 200) {
                    let result = await response.json();
                    if (result) {                                                
                        setReasonResult(result);
                        let array = [];
                        for (let i = 0; i < result.length; i++) {
                            let t = {
                                "sku": result[i]?.sku,
                                "shipment_id": result[i]?.shipment_id,
                                "return_lineitem_id": result[i]?.return_lineitem_id,
                                "return_attribute": {
                                    "return_reason": {
                                        "code": "",
                                        "title": ""
                                    },
                                    "return_sub_reason": {
                                        "code": "",
                                        "title": ""
                                    },
                                    "item_condition": {
                                        "code": "",
                                        "title": ""
                                    },
                                    "customer_notes": "",
                                    "uploaded_images": [],
                                },
                            }
                            array.push(t)
                        }
                        setSelectedDummyReasonData(JSON.parse(JSON.stringify(array)));
                        sessionStorage.setItem('selectedDummyReasonData', JSON.stringify(array));
                        setSelectedReasonData(array);
                    }
                }
                else {
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });

                }
                setIsLoaderEnable(false);
            }
            catch (error) {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                setIsLoaderEnable(false);
            }
        }
        if (sessionStorage.getItem('RPI') && !(reasonData && reasonData.length > 0)) {
            getReasons();
        }
        else {
            setReasonResult(reasonData);
            let array = [];
            for (let i = 0; i < reasonData.length; i++) {
                let t = {
                    "sku": reasonData[i]?.sku,
                    "shipment_id": reasonData[i]?.shipment_id,
                    "return_lineitem_id": reasonData[i]?.return_lineitem_id,
                    "return_attribute": {
                        "return_reason": {
                            "code": "",
                            "title": ""
                        },
                        "return_sub_reason": {
                            "code": "",
                            "title": ""
                        },
                        "item_condition": {
                            "code": "",
                            "title": ""
                        },
                        "customer_notes": "",
                        "uploaded_images": [],
                    },
                }
                array.push(t)
            }
            setSelectedDummyReasonData(JSON.parse(JSON.stringify(array)));
            sessionStorage.setItem('selectedDummyReasonData', JSON.stringify(array));
            setSelectedReasonData(array);
        }
        if (JSON.parse(sessionStorage.getItem('config-data'))?.return_workflow_steps?.refund_method_selection?.skipped) {
            setSteps(['Why are you returning this item(s)?', 'How would you like to return your item(s)?', 'Review and Confirm Returns'])
        }

    if (containerRef.current) {
        const script = document.createElement('script');
        script.text = `var accs = document.querySelectorAll('[id^="accordionToggle"]');
  accs.forEach((acc) => {
    acc.addEventListener('click', function () {
      var body = this.parentElement.nextElementSibling;
      var isOpen = body.style.display === 'block';
      var icon = this.querySelector('i');

      body.style.display = isOpen ? 'none' : 'block';
      this.innerHTML = isOpen
        ? 'show more <i class="fa-solid fa-chevron-down"></i>'
        : 'show less <i class="fa-solid fa-chevron-up"></i>';
    });
    });`;
      containerRef.current.appendChild(script);
    }
    }, [reasonData,containerRef.current]);

    // const getRefundData = async () => {
    //     try {
    //         const response = await fetch(RETURNS_UI_URLS.BASE_URL + 'return/rpi/' + (JSON.parse(sessionStorage.getItem('RPI'))?.rpi_number) + '/refunds', {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId)
    //             }
    //         })
    //         if (!response) {
    //             setSnackOpen(true);
    //             setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
    //         }
    //         if (response?.status === 200) {
    //             let result = await response.json();
    //             if (result) {
    //                 setRefundData(result);
    //             }
    //         }
    //         else {
    //             setSnackOpen(true);
    //             setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });

    //         }
    //     }
    //     catch (error) {
    //         setSnackOpen(true);
    //         setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
    //         setIsLoaderEnable(false);
    //     }
    // }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackOpen(false);
    };

    const scrollToParticularSection = (id) => {
        const violation = document.getElementById(id);
        violation?.scrollIntoView({
            block: 'start',
        });
    }

    const updateReturnReason = async (event) => {
        let dd = JSON.parse(JSON.stringify(selectedReasonData))
        for (let i = 0; i < dd.length; i++) {
            delete dd[i].return_attribute.item_condition.description;
            delete dd[i].return_attribute.return_reason.preferences;
            delete dd[i].return_attribute.return_reason.sub_reasons;
        }
        if (JSON.stringify(selectedDummyReasonData) !== JSON.stringify(selectedReasonData)) {
            setSelectedDummyReasonData(JSON.parse(JSON.stringify(selectedReasonData)));
            try {
                const response = await fetch(RETURNS_UI_URLS.BASE_URL + 'return/' + (JSON.parse(sessionStorage.getItem('RPI'))?.rpi_number) + '/selected-return-attributes', {
                    method: 'POST',
                    body: JSON.stringify(dd),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId),
                    }
                })
                if (!response) {
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                }
                if (response?.status === 200) {
                    setIsBackButtonDisable(true);
                    let result = await response.json();
                    setSelectedDummyReasonData(JSON.parse(JSON.stringify(selectedReasonData)));
                    if (!(JSON.parse(sessionStorage.getItem('config-data'))?.return_workflow_steps?.refund_method_selection?.skipped)) {
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                        setSelectedPayment([]);
                        paymentMethod(result?.consolidated_refund_methods);
                        setTimeout(() => {
                            scrollToParticularSection('order-wrapper');
                        }, 200)
                    }
                    else {
                        setActiveStep((prevActiveStep) => prevActiveStep + 2);
                        setSelectedShipment([]);
                        shippingMethod(result?.consolidated_return_methods);
                        setTimeout(() => {
                            scrollToParticularSection('order-wrapper');
                        }, 200)
                    }
                }
                else {
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                }
            }
            catch (error) {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            }
        } else {
            if (!(JSON.parse(sessionStorage.getItem('config-data'))?.return_workflow_steps?.refund_method_selection?.skipped)) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 2);
            }
            setTimeout(() => {
                scrollToParticularSection('order-wrapper');
            }, 200)
        }
    }
    const updateRefundMethod = async (event) => {
        if (JSON.stringify(selectedPayment) !== JSON.stringify(selectedDummyPayment)) {
            setSelectedDummyPayment(selectedPayment);
            try {
                const response = await fetch(RETURNS_UI_URLS.BASE_URL + 'return/' + (JSON.parse(sessionStorage.getItem('RPI'))?.rpi_number) + '/selected-refund-methods', {
                    method: 'POST',
                    body: JSON.stringify(selectedPayment),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId),
                    }
                })
                if (!response) {
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                }
                if (response?.status === 200) {
                    setIsBackButtonDisable(true);
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    setSelectedDummyPayment(selectedPayment);
                    let result = await response.json();
                    setSelectedShipment([]);
                    shippingMethod(result?.consolidated_return_methods);
                    setTimeout(() => {
                        scrollToParticularSection('order-wrapper');
                    }, 200)
                }
                else {
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                }
            }
            catch (error) {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            }
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setTimeout(() => {
                scrollToParticularSection('order-wrapper');
            }, 200)
        }
    }

    const updateReturnMethod = async (event) => {
        if (JSON.stringify(selectedShipment) !== JSON.stringify(selectedDummyShipment)) {
            setSelectedDummyShipment(selectedShipment);
            try {
                const response = await fetch(RETURNS_UI_URLS.BASE_URL + 'return/' + (JSON.parse(sessionStorage.getItem('RPI'))?.rpi_number) + '/selected-return-methods', {
                    method: 'POST',
                    body: JSON.stringify(selectedShipment),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId),
                    }
                })
                if (!response) {
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                }
                if (response?.status === 200) {
                let result = await response.json();
                if(result){
                      setRefundData(result);
                }
                    setIsBackButtonDisable(true);
                    setTimeout(() => {
                        // getRefundData();
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    }, 700)
                    setTimeout(() => {
                        scrollToParticularSection('order-wrapper');
                    }, 200)
                }
                else {
                    setSnackOpen(true);
                    setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                }
            }
            catch (error) {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            }
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setTimeout(() => {
                scrollToParticularSection('order-wrapper');
            }, 200)
        }
    }
   const getItemWiseAmount = (data) => {
    let amount = 0;
       for (let i = 0; i < data.length; i++) {
        amount = amount + data[i].price_breakdown?.total_price?.amount
        
       }
       return amount
   }
    const returnReasonChange = (event, sku, shipId, index) => {
        let data = [...selectedReasonData]
        let i = data?.findIndex((obj) => obj.sku === sku);
        if (i !== -1) {
            data[i].return_attribute.return_reason = event.target.value;
            data[i].return_attribute.return_sub_reason = { title: '', code: '' };
            data[i].return_attribute.customer_notes = '';
        }
        setSelectedReasonData(data);
        //subreasons get
        let d = reasonsResult[index].return_attributes.reasons.findIndex((obj) => obj.title === event.target.value?.title);
        let t = { sku: sku, shipment_id: shipId, subReasons: reasonsResult[index].return_attributes.reasons[d] };
        let sub = [...getSubReasonData];
        let j = sub?.findIndex((obj) => obj.sku === sku);
        if (j !== -1) {
            sub[j] = t;
        }
        else {
            sub.push(t);
        }
        setGetSubReasonData(sub);
    };

    const returnSubReasonChange = (event, sku, shipId) => {
        let data = [...selectedReasonData]
        let i = data?.findIndex((obj) => obj.sku === sku && obj.shipment_id === shipId);
        if (i !== -1) {
            data[i].return_attribute.return_sub_reason = event.target.value;
        }
        setSelectedReasonData(data);
    }

    const returnItemCondition = (event, sku, shipId) => {
        let data = [...selectedReasonData]
        let i = data?.findIndex((obj) => obj.sku === sku && obj.shipment_id === shipId);
        if (i !== -1) {
            data[i].return_attribute.item_condition = event.target.value;
        }
        setSelectedReasonData(data);
    }

    const commentChange = (event, sku, shipId) => {
        let data = [...selectedReasonData]
        let i = data?.findIndex((obj) => obj.sku === sku && obj.shipment_id === shipId);
        if (i !== -1) {
            data[i].return_attribute.customer_notes = event.target.value;
        }
        setSelectedReasonData(data);
        let data1 = [...getSubReasonData]
        let j = data1?.findIndex((obj) => obj.sku === sku && obj.shipment_id === shipId)
        if (data[i]?.return_attribute.customer_notes.length >= data1[j].subReasons?.preferences.comment_max_char_size) {
            return false;
        }
        else {
            return true;
        }
    };

    const compressImage = (file) => new Promise((resolve) => {
        const objectUrl = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(objectUrl);
            const MAX_DIM = 2048;
            let { width, height } = img;
            if (width > MAX_DIM || height > MAX_DIM) {
                if (width >= height) { height = Math.round(height * MAX_DIM / width); width = MAX_DIM; }
                else { width = Math.round(width * MAX_DIM / height); height = MAX_DIM; }
            }
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(img, 0, 0, width, height);
            canvas.toBlob(
                (blob) => resolve(blob
                    ? new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' })
                    : file),
                'image/jpeg', 0.8
            );
        };
        img.onerror = () => { URL.revokeObjectURL(objectUrl); resolve(file); };
        img.src = objectUrl;
    });

    const handleImageUpload = async (event, sku, shipId, index, maxImages) => {
        const files = Array.from(event.target.files);
        event.target.value = '';
        if (!files.length) return;
        const currentCount = selectedReasonData[index]?.return_attribute?.uploaded_images?.length || 0;
        const remaining = (maxImages || 5) - currentCount;
        if (remaining <= 0) return;
        const filesToUpload = files.slice(0, remaining);

        const ALLOWED_MIME_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif']);
        const ALLOWED_EXTENSIONS = new Set(['.jpg', '.jpeg', '.png', '.webp', '.heic', '.heif']);
        const invalidFile = filesToUpload.find(f => {
            const type = f.type.toLowerCase();
            if (!type) {
                const ext = '.' + f.name.split('.').pop().toLowerCase();
                return !ALLOWED_EXTENSIONS.has(ext);
            }
            return !ALLOWED_MIME_TYPES.has(type);
        });
        if (invalidFile) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Unsupported file type. Please upload a JPEG, PNG, WebP, or HEIC image.' });
            return;
        }

        const compressedFiles = await Promise.all(filesToUpload.map(compressImage));
        const oversized = compressedFiles.find(f => f.size > 10 * 1024 * 1024);
        if (oversized) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'That image is too large. Please upload a file smaller than 10MB' });
            return;
        }

        const key = `${sku}-${shipId}`;
        setUploadingImages(prev => ({ ...prev, [key]: true }));
        try {
            const formData = new FormData();
            compressedFiles.forEach(file => formData.append('image_or_document', file));
            const rpiNumber = JSON.parse(sessionStorage.getItem('RPI'))?.rpi_number;
            const uploadUrl = FILE_UPLOAD.FILE_UPLOAD_URL + (rpiNumber ? `?return_id=${rpiNumber}` : '');
            const response = await fetch(uploadUrl, {
                method: 'POST',
                headers: { 'X-Fenix-Tenant-Id': JSON.parse(sessionStorage.getItem('retailerData')).tenantId },
                body: formData,
            });
            if (response?.status === 200) {
                const uploaded = await response.json();
                let data = [...selectedReasonData];
                let i = data.findIndex(obj => obj.sku === sku && obj.shipment_id === shipId);
                if (i !== -1) {
                    data[i].return_attribute.uploaded_images = [...data[i].return_attribute.uploaded_images, ...uploaded];
                }
                setSelectedReasonData(data);
            } else {
                const errorBody = await response.json().catch(() => null);
                const msg = errorBody?.error_message || 'Image upload failed. Please try again.';
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg });
            }
        } catch (error) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Image upload failed. Please try again.' });
        } finally {
            setUploadingImages(prev => ({ ...prev, [key]: false }));
        }
    };

    const handleRemoveImage = (sku, shipId, index, imageId) => {
        let data = [...selectedReasonData];
        let i = data.findIndex(obj => obj.sku === sku && obj.shipment_id === shipId);
        if (i !== -1) {
            data[i].return_attribute.uploaded_images = data[i].return_attribute.uploaded_images.filter(img => img.image_id !== imageId);
        }
        setSelectedReasonData(data);
    };

    const paymentMethod = (result) => {
        if (result?.length > 0) {
            setPaymentData(result);
            let array = [];
            for (let i = 0; i < result.length; i++) {                
                let t = {
                    "skus": result[i]?.skus,
                    "return_lineitem_ids":result[i]?.return_lineitem_ids,
                    "refund_method": result[i].refund_methods[0]
                }
                array.push(t);
            }
            setSelectedPayment(array);
        }
        else {
            setPaymentData(null);
        }

    }


    const changePayment = (event, index, methods) => {
        let data = [...selectedPayment];
        let i = methods?.findIndex((obj) => obj?.name === event.target.value);
        if (i !== -1) {
            data[index].refund_method = methods[i];
        }
        setSelectedPayment(data);
    }

    const shippingMethod = async (result) => {
        if (result?.length > 0) {
            setShipmentData(result);
            let array = [];
            for (let i = 0; i < result.length; i++) {
                let t = {
                    "skus": result[i]?.skus,
                    "return_lineitem_ids":result[i]?.return_lineitem_ids,
                    "rule_id": result[i]?.return_location_method_bundle_summary.rule_id,
                    "destination_address": result[i]?.return_location_method_bundle_summary.destination_address,
                    "location_id": result[i]?.return_location_method_bundle_summary.location_id,
                    "return_method": result[i]?.return_location_method_bundle_summary.return_method_summaries[0]
                }
                array.push(t);
            }
            setSelectedShipment(array);
            setTimeout(() => {
                includeScriptCodeForShowMore();
            }, 1000);
        }
        else {
            setShipmentData(null);
        }
    }

    const changeShipment = (event, index, methods) => {
        let data = [...selectedShipment]
        let i = methods?.findIndex((obj) => obj?.name === event.target.value);
        if (i !== -1) {
            data[index].return_method = methods[i];
        }
        setSelectedShipment(data);
    }

    const returnRequest = async () => {
        setConfirmingReturn(true);
        try {
            const response = await fetch(RETURNS_UI_URLS.BASE_URL + 'return/' + (JSON.parse(sessionStorage.getItem('RPI'))?.rpi_number) + '/confirm-return', {
                method: 'POST',
                body: {},
                headers: {
                    'Content-Type': 'application/json',
                    'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId)
                }
            });
            if (!response) {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            }
            if (response?.status === 200) {
                setIsBackButtonDisable(false);
                setSnackOpen(true);
                setSnackbarProp({ style: 'success', msg: 'Return request is successful.' });
                setSelectedDummyReasonData(selectedReasonData);
                sessionStorage.removeItem('returnItemData');
                sessionStorage.removeItem('selectedReasonData');
                sessionStorage.removeItem('selectedDummyReasonData');
                sessionStorage.removeItem('isSelectedLineItems');
                setTimeout(() => {
                    setIsSubmitted(true);
                }, 1000);

                setTimeout(() => {
                    setConfirmingReturn(false);
                    let data2 = '/my-returns' + (document.location.search ? document.location.search : '');
                    navigate(data2.replace(/"/g, ""));
                    navigateToReturned('2');
                }, 1000)
            }
            else {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            }
        }
        catch (error) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
        }
    }
    const formatingDateForDisplay = (date) => {
        return date ? dateFormat(new Date(date), "mmmm d, yyyy") : '';
    }

    const addDefaultImg = ev => {
        ev.target.src = "/shopping-bag.png";
        ev.target.style = 'width:45%';

    }

    const isValidReasons = (event) => {
        let flag = true;
        sessionStorage.setItem('selectedReasonData', JSON.stringify(selectedReasonData));
        for (let i = 0; i < selectedReasonData.length; i++) {
            let sub = [...getSubReasonData];
            let j = sub?.findIndex((obj) => obj.sku === selectedReasonData[i].sku);
            if (j !== -1) {
                if (selectedReasonData[i]?.return_attribute.return_reason.title && ((sub[j]?.subReasons?.preferences?.display_sub_reason) ? (selectedReasonData[i]?.return_attribute?.return_sub_reason?.title) : true) && ((sub[j]?.subReasons?.preferences?.check_item_conditions) ? (selectedReasonData[i]?.return_attribute?.item_condition?.title) : true) &&
                    ((sub[j]?.subReasons?.preferences?.capture_comments) ? (selectedReasonData[i]?.return_attribute.customer_notes) : true)) {
                    flag = false
                } else {
                    flag = true;
                    break;
                }
            }
            else {
                flag = true;
                break;
            }
        }
        return flag;
    }

    const NoIcon = styled('span')(({ theme }) => ({
        display: 'none',
    }));

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        if (activeStep === 0) {
            updateReturnReason();
        }
        else if (activeStep === 1) {
            updateRefundMethod();
        }
        else if (activeStep === 2) {
            updateReturnMethod();
        }
        else if (activeStep === 3) {
            setArrowButtonEnable(true);
            setDisableReturnBtn(true);
            returnRequest();
        }
    };

    const handleBack = () => {
        if (activeStep === 2 ? JSON.parse(sessionStorage.getItem('config-data'))?.return_workflow_steps?.refund_method_selection?.skipped : false) {
            setActiveStep((prevActiveStep) => prevActiveStep - 2);
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
        setTimeout(() => {
            scrollToParticularSection('order-wrapper');
        }, 200)
    };

    const orderInfoContent = (linedata) => {
        return (
            <>
                <div className='order-image-wrapper'>
                    <div className={`order-image ${!linedata.image_url ? 'no-order-image' : ''} `}>
                        {data1.type !== 'fluentcommerce' ?
                            <img
                                className={`img-block border-image mb-10 cursor-pointer ${!linedata.image_url ? "width-45per" : ""}`}
                                onClick={() => window.open(linedata?.routing_url ? linedata?.routing_url : data1?.store_url)} alt='linedata' src={linedata.image_url ? `${linedata.image_url}` : '/shopping-bag.png'}
                                onError={addDefaultImg} style={{ width: 100 + 'px' }}
                            /> :
                            <img
                                className={`img-block border-image mb-10 cursor-pointer ${!linedata.image_url ? "width-45per" : ""}`}
                                onClick={() => window.open(data1?.store_url)} alt='linedata'
                                src={linedata.image_url ? `${linedata.image_url}` : '/shopping-bag.png'}
                                onError={addDefaultImg}
                                style={{ width: 100 + 'px' }}
                            />
                        }
                    </div>
                    <div className={`product_name_wrapper ${data?.type} cursor-pointer`}>
                        <h4 className={`display-ellipsis ${data?.type}`}>
                            {linedata?.product_name}
                        </h4>
                    </div>
                </div>
                <div className="order-desc flex-grow-1">
                    <div className='desc-content'>
                        <div className='product_info'>
                           {
                                linedata?.product_name ? <div className={`product_name_wrapper ${data?.type}`}>
                                    <h4 className={`display-ellipsis ${data?.type}`}>
                                        {linedata?.product_name}
                                    </h4>
                                </div> : (
                                    <>
                                        <div className={`product_name_wrapper ${data?.type}`}>
                                            <h4 className={`display-ellipsis ${data?.type}`}>
                                                {linedata?.sku}
                                            </h4>
                                        </div>
                                    </>
                                )
                            }
							
						{data1?.type !== 'janieandjack' ? (linedata.price_breakdown?.total_price?.amount ? <span>$ {linedata.price_breakdown?.total_price?.amount.toFixed(2)}</span> : null) : ''}
                            {(linedata?.color || linedata?.size || linedata.returnable_quantity) ?
                                <div className={`size_color_wrapper ${activeStep === 3 ? 'flex-wrap' : ''}`}>
                                    {/* {
                                        linedata.returnable_quantity ? <span>Selected Qty: {linedata.returnable_quantity}</span> : null
                                    } */}
                                    {displaySizeandColor(linedata?.size, linedata?.color,linedata.returnable_quantity)}
                                </div> : ''
                            }
                            {(linedata?.vendor) ?
                                <div className="size_color_wrapper"><span>Sold and Shipped by: {linedata?.vendor}</span></div> : null
                            }
                            {/* {
                                (activeStep === 3 && data1.type !== 'janieandjack') ? (
                                    <>
                                        <label className={`total_refund_label ${data1?.type}`}>Total Refunds: $ {refundData?.total_refunds?.amount ? refundData?.total_refunds?.amount : 0}</label>
                                    </>
                                ) : null
                            } */}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div className={`container return-item-wrapper ${data1?.type}`} id="section_1">
            <Breadcrumbs className='return-item-wrapper-navigation' aria-label="breadcrumb">
                <Link underline="hover" color="inherit" onClick={navigateToMyOrders} className="f-14 cursor-pointer"><img alt="" className='' src={arrowLeftIcon} /></Link>
                <Typography color="text.primary" className="f-14 fw-500 text-color cursor-pointer">Return Item</Typography>
            </Breadcrumbs>
            <div className="row">
                <div className="p-16 col-12">
                    <div className="mb-3">
                        <div className='stepper-container'>
                            <button
                                className='stepper-navigation-btn stepper-prev-btn'
                                disabled={activeStep === 0}
                                onClick={handleBack}>
                                <img alt='' src={downArrowIcon} />
                            </button>
                            <Stepper activeStep={(activeStep >= 2 && JSON.parse(sessionStorage.getItem('config-data'))?.return_workflow_steps?.refund_method_selection?.skipped) ? activeStep + 1 : activeStep}
                                alternativeLabel
                                className={`return-item-stepper ${data1?.type}`}>
                                {steps.map((label, index) => {
                                    const stepProps = {};
                                    const labelProps = {};
                                    if (isStepSkipped(index)) {
                                        stepProps.completed = false;
                                    }
                                    return (
                                        <Step key={label} {...stepProps} completed={false} className={activeStep >= 2 && JSON.parse(sessionStorage.getItem('config-data'))?.return_workflow_steps?.refund_method_selection?.skipped ? (activeStep === index + 1 ? 'active-step' : '') : (activeStep === index ? 'active-step' : '')}>
                                            <StepLabel {...labelProps}
                                                className={`${activeStep > index ? 'show-active' : ''}`}>
                                                {label}
                                            </StepLabel>
                                        </Step>
                                    );
                                })}
                            </Stepper>
                            <button className='stepper-navigation-btn stepper-next-btn'
                                disabled={!arrowButtonEnable}
                                onClick={handleNext}>
                                <img alt="" src={downArrowIcon} />
                            </button>
                        </div>
                        <div className="row">
                            <div className="col-12 card-wrap order-placed-list">
                                <div className={`order-placed-list-inner step-${activeStep}`}>
                                    <div className="card order-placed-list-box">
                                        <div className={`${activeStep !== 0 ? 'd-none ' : ''} card-header row mx-0 align-items-start`}>
                                            <div className="col-md-8 cheader-headings-wrap">
                                                <div className="cheader-headings">
                                                    <div className={`cheader-label ${data1?.type}`}>Order Placed</div>
                                                    <div className={`fw-600 ${data1?.type} cheader-title`}>{orderData.date_place?.formatted_dttm ? formatingDateForDisplay(orderData.date_place.formatted_dttm) : ''}</div>
                                                </div>
                                                {data1?.type !== 'janieandjack' ? <div className="cheader-headings">
                                                    <div className={`cheader-label ${data1?.type}`}>Total</div>
                                                    <div className={`fw-600 ${data1?.type} cheader-title`}>$ {getItemWiseAmount(data?.line_data).toFixed(2)}</div>
                                                </div> : ''}
                                                <div className="cheader-headings ship-to-headings">
                                                    <div className={`cheader-label ${data1?.type}`}>Ship to</div>
                                                    <HtmlTooltipForAddress enterTouchDelay={0} className={`shipto-tooltip ${data1?.type}`}
                                                        title={
                                                            <React.Fragment>
                                                                {/* onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} */}
                                                                <div>
                                                                    <h4>{orderData?.address?.name}</h4>
                                                                    <p>{orderData?.address?.address1} {orderData?.address?.city},&nbsp;{orderData?.address?.province} {orderData?.address?.country}, &nbsp;{orderData?.address?.zip_code}</p>
                                                                </div>
                                                            </React.Fragment>
                                                        }
                                                    >
                                                        <div className={`fw-600 ${retailerInfo?.type} cursor-pointer cheader-title`}>
                                                            {orderData?.address.name}
                                                            <span className="text-color">
                                                                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.2126 0.671822C11.4957 0.945189 11.4957 1.3884 11.2126 1.66177L6.37841 6.32844C6.09523 6.60181 5.63611 6.60181 5.35293 6.32844L0.787335 1.92103C0.504156 1.64766 0.504156 1.20445 0.787335 0.931081C1.07051 0.657714 1.52964 0.657714 1.81282 0.931081L5.86567 4.84351L10.1871 0.671822C10.4703 0.398455 10.9294 0.398455 11.2126 0.671822Z" fill="#78829D" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </HtmlTooltipForAddress>
                                                </div>
                                            </div>
                                            <div className="col-md-4 cheader-order-number">
                                                <div className="cheader-headings">
                                                    <div className={`fw-600 cheader-label ${data1?.type}`}>Order Number: </div>
                                                    <div className={`fw-600 cheader-title ${data1?.type}`}>{orderData?.order_number}</div>
                                                </div>
                                            </div>
                                            <div className='col-12 order-number-container'>
                                                <div className='order-number-header'>
                                                    <span className='order-number-title'>Order Number:</span>
                                                    <HtmlTooltipForAddress
                                                        enterTouchDelay={0}
                                                        placement="bottom-end"
                                                        className="order-info-tooltip"
                                                        title={
                                                            <React.Fragment>
                                                                <div>
                                                                    <div className="fw-500 pd-5 tooltip-wd order-info-tooltip-inner">
                                                                        <div>
                                                                            <span>
                                                                                Order Placed :
                                                                            </span>
                                                                            <label>
                                                                                {orderData.date_place?.formatted_dttm ? formatingDateForDisplay(orderData.date_place?.formatted_dttm) : ''}
                                                                            </label>
                                                                        </div>
                                                                        {data1?.type !== 'janieandjack' ?
                                                                            <div>
                                                                                <span>
                                                                                    Total :
                                                                                </span>
                                                                                <label>
                                                                                    $ {getItemWiseAmount(data?.line_data).toFixed(2)}
                                                                                </label>
                                                                            </div> : ''}
                                                                        <div>
                                                                            <span>
                                                                                Ship to :
                                                                            </span>
                                                                            <label>
                                                                                {orderData?.address.name}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        }
                                                    >
                                                        <span
                                                            className={`order-number-value fw-600 ${data1?.type} cursor-pointer`}>{data.order_number} </span>
                                                    </HtmlTooltipForAddress>
                                                </div>
                                            </div>
                                        </div>
                                        {data?.line_data?.length > 0 ?
                                            <div className='card-body'>
                                                {
                                                    activeStep === 0 ?
                                                        <div className={`order-info-wrapper ${data?.line_data?.length > 5 ? 'max-height-50 mb-20 auto-overflowY hidden-overflowX' : ''}`} >
                                                            {data?.line_data.map((linedata, j) => (
                                                                <Fragment>
                                                                    <div className='order-info' key={j}>
                                                                        {orderInfoContent(linedata)}
                                                                        <div className='return-dynamic-container '>
                                                                            <div className='return-dynamic-items-wrapper'>
                                                                                {!isLoaderEnable ? reasonsResult?.map((obj, index) => {
                                                                                    return (linedata.sku === obj.sku && obj.shipment_id === linedata.shipment_id) ?
                                                                                        (
                                                                                            <>
                                                                                                <div className='step-0'>
                                                                                                    <div className='form-group why-are-you-returning-content'>
                                                                                                        <label className="required">Why are you returning this item? </label>
                                                                                                        <div className="drop-down">
                                                                                                            <FormControl sx={{ m: 0 }} fullWidth size="small">
                                                                                                                <Select classes={{
                                                                                                                    root: "result-select-root",
                                                                                                                }}
                                                                                                                    disabled={isSubmitted}
                                                                                                                    IconComponent={NoIcon}
                                                                                                                    value={selectedReasonData[index]?.return_attribute.return_reason.title ? selectedReasonData[index]?.return_attribute.return_reason : ''}
                                                                                                                    className={`${data1.type} ${selectedReasonData[index]?.return_attribute.return_reason.title ? selectedReasonData[index]?.return_attribute.return_reason !== '' ? 'dark-color' : 'light-color' : 'light-color'} form-select p-10 border-line select-h-35 box-shadow-none cursor-pointer f-14`}
                                                                                                                    defaultValue={''}
                                                                                                                    displayEmpty
                                                                                                                    onChange={(e) => returnReasonChange(e, obj.sku, obj.shipment_id, index)}
                                                                                                                >
                                                                                                                    <MenuItem className={`f-14 ${data1.type + '-menuitem'}`} value="">Select any Reason</MenuItem>
                                                                                                                    {obj?.return_attributes?.reasons.map((e, key) => {
                                                                                                                        return <MenuItem className={`${data1.type + '-menuitem'}`} key={key} value={e}
                                                                                                                            sx={{ whiteSpace: 'normal', wordWrap: 'break-word', mr: 2 }}>{e.title}</MenuItem>
                                                                                                                    })}
                                                                                                                </Select>
                                                                                                            </FormControl>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {getSubReasonData.map((sub, j) => sub.sku === linedata.sku && sub.shipment_id === linedata.shipment_id && (sub?.subReasons?.sub_reasons?.length > 0) && (sub?.subReasons?.preferences?.display_sub_reason) ?
                                                                                                        (
                                                                                                            <div className="form-group please-tell-us-more-content">
                                                                                                                <label className="required">Please tell us more</label>
                                                                                                                <div className="drop-down">
                                                                                                                    <FormControl sx={{ m: 0 }} fullWidth size='small'>
                                                                                                                        <Select
                                                                                                                            disabled={isSubmitted}
                                                                                                                            IconComponent={NoIcon}
                                                                                                                            value={selectedReasonData[index]?.return_attribute.return_sub_reason.title ? selectedReasonData[index]?.return_attribute.return_sub_reason : ''}
                                                                                                                            className={`${data1.type} ${selectedReasonData[index]?.return_attribute.return_sub_reason.title ? selectedReasonData[index]?.return_attribute.return_sub_reason.title !== '' ? 'dark-color' : 'light-color' : 'light-color'} form-select p-10 select-h-35 border-line box-shadow-none cursor-pointer f-14`}
                                                                                                                            defaultValue={''}
                                                                                                                            displayEmpty
                                                                                                                            onChange={(e) => returnSubReasonChange(e, obj.sku, obj.shipment_id)}
                                                                                                                            aria-label="Default select example"
                                                                                                                        >
                                                                                                                            <MenuItem className={`f-14 ${data1.type + '-menuitem'}`} value="">Select any Sub Reason</MenuItem>
                                                                                                                            {sub?.subReasons?.sub_reasons.map((e, key) => {
                                                                                                                                return <MenuItem className={`${data1.type + '-menuitem'}`} key={key} value={e}>{e.title}</MenuItem>
                                                                                                                            })}
                                                                                                                        </Select>
                                                                                                                    </FormControl>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        ) : '')}
                                                                                                    {obj?.return_attributes?.item_conditions?.length > 0 && selectedReasonData[index]?.return_attribute?.return_reason && getSubReasonData.map((sub) => sub.sku === linedata.sku && sub.shipment_id === linedata.shipment_id && sub?.subReasons?.preferences?.check_item_conditions ?
                                                                                                        <div className="form-group item-conditon-content">
                                                                                                            <label className="required">Item Condition</label>
                                                                                                            <div className='drop-down'>
                                                                                                                <FormControl sx={{ m: 0 }} fullWidth size='small'>
                                                                                                                    <Select
                                                                                                                        disabled={isSubmitted}
                                                                                                                        IconComponent={NoIcon}
                                                                                                                        value={selectedReasonData[index]?.return_attribute?.item_condition.title ? selectedReasonData[index]?.return_attribute?.item_condition : ''}
                                                                                                                        className={`${data1.type} ${selectedReasonData[index]?.return_attribute?.item_condition.title ? selectedReasonData[index]?.return_attribute?.item_condition.title !== '' ? 'dark-color' : 'light-color' : 'light-color'} form-select select-h-35 p-10 border-line box-shadow-none cursor-pointer f-14`}
                                                                                                                        displayEmpty
                                                                                                                        defaultValue={''}
                                                                                                                        onChange={(e) => returnItemCondition(e, obj.sku, obj.shipment_id)}
                                                                                                                        aria-label="Default select example"
                                                                                                                    >
                                                                                                                        <MenuItem className={`f-14 ${data1.type + '-menuitem'}`} value="">Select Item Condition</MenuItem>
                                                                                                                        {obj?.return_attributes?.item_conditions.map((data, key) => {
                                                                                                                            return <MenuItem className={`${data1.type + '-menuitem'}`} key={key} value={data}>{data.title}</MenuItem>
                                                                                                                        })}
                                                                                                                    </Select>
                                                                                                                </FormControl>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        : '')}
                                                                                                    {getSubReasonData.map((sub, l) => sub.sku === linedata.sku ?
                                                                                                        <div className="form-group additional-information-content">
                                                                                                            <label className={`${sub.sku === linedata.sku && sub?.subReasons?.preferences?.capture_comments ? 'required' : ''}`}>Additional Information</label>
                                                                                                            <div className="text-area f-14">
                                                                                                                <textarea name="post content" placeholder='Write additional information here' value={selectedReasonData[index]?.return_attribute?.customer_notes ? selectedReasonData[index]?.return_attribute?.customer_notes : ''} className={`br-10 p-12 full-width border-line ${data1.type} ${isSubmitted ? 'op-5 cursor-not-allowed' : ''}`} maxLength={500} rows={2} onChange={(e) => commentChange(e, obj.sku, obj.shipment_id)} />
                                                                                                                {!isSubmitted ? <p>{(selectedReasonData[index]?.return_attribute.customer_notes.length ? selectedReasonData[index]?.return_attribute.customer_notes.length : 0)} / {(sub?.subReasons?.preferences.comment_max_char_size ? sub?.subReasons?.preferences.comment_max_char_size : 0)} </p>
                                                                                                                    : ''}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        : '')}
                                                                                                    {getSubReasonData.map((sub, l) => sub.sku === linedata.sku && sub.shipment_id === linedata.shipment_id && sub?.subReasons?.preferences?.capture_product_images ?
                                                                                                        <div className="form-group image-upload-content">
                                                                                                            <label>Upload Photos <span className="f-12 fw-normal text-muted">(optional)</span>
                                                                                                                <span className="image-upload-count f-12">
                                                                                                                    &nbsp;({selectedReasonData[index]?.return_attribute?.uploaded_images?.length || 0} / {sub?.subReasons?.preferences?.max_images_can_upload || 5})
                                                                                                                </span>
                                                                                                            </label>
                                                                                                            {!isSubmitted && (selectedReasonData[index]?.return_attribute?.uploaded_images?.length || 0) < (sub?.subReasons?.preferences?.max_images_can_upload || 5) &&
                                                                                                                <div className="image-upload-trigger">
                                                                                                                    <label className="custom-file-upload" htmlFor={`file-upload-${obj.sku}-${obj.shipment_id}`}>
                                                                                                                        {uploadingImages[`${obj.sku}-${obj.shipment_id}`] ? 'Uploading...' : '+ Add Photos'}
                                                                                                                    </label>
                                                                                                                    <input
                                                                                                                        id={`file-upload-${obj.sku}-${obj.shipment_id}`}
                                                                                                                        type="file"
                                                                                                                        accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif"
                                                                                                                        multiple
                                                                                                                        disabled={uploadingImages[`${obj.sku}-${obj.shipment_id}`]}
                                                                                                                        onChange={(e) => handleImageUpload(e, obj.sku, obj.shipment_id, index, sub?.subReasons?.preferences?.max_images_can_upload)}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            }
                                                                                                            {selectedReasonData[index]?.return_attribute?.uploaded_images?.length > 0 &&
                                                                                                                <div className="uploaded-images-preview">
                                                                                                                    {selectedReasonData[index].return_attribute.uploaded_images.map((img, imgIdx) => (
                                                                                                                        <div key={img.image_id} className="uploaded-image-item">
                                                                                                                            <img src={img.image_url} alt={`upload-${imgIdx}`} className="uploaded-image-thumb" />
                                                                                                                            {!isSubmitted &&
                                                                                                                                <button type="button" className="remove-image-btn" onClick={() => handleRemoveImage(obj.sku, obj.shipment_id, index, img.image_id)}>×</button>
                                                                                                                            }
                                                                                                                        </div>
                                                                                                                    ))}
                                                                                                                </div>
                                                                                                            }
                                                                                                        </div>
                                                                                                        : '')}
                                                                                                    {JSON.parse(sessionStorage.getItem('config-data')).policy_enforcement_message?.display && <div className={`return-info-container ${data1?.type}`}>
                                                                                                        <div className='return-info-header'>
                                                                                                            <img width={14} height={14} className="return-info-icon" src={infoIcon} alt="info-icon" />
                                                                                                            <h4>{JSON.parse(sessionStorage.getItem('config-data')).policy_enforcement_message?.title}</h4>
                                                                                                        </div>
                                                                                                        <p>{JSON.parse(sessionStorage.getItem('config-data')).policy_enforcement_message?.content}</p>
                                                                                                    </div>}
                                                                                                </div>
                                                                                            </>
                                                                                        ) : ''

                                                                                }
                                                                                ) : <div className="loader mt-2rem item-center">Loading...</div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Fragment>

                                                            ))
                                                            }
                                                        </div>
                                                        : (
                                                            activeStep === 1 ? (
                                                                <>
                                                                    {paymentData && paymentData.length > 0 ? paymentData?.map((payData, index) => {
                                                                        return <div className="order-info-container">
                                                                            <div className={`order-info-wrapper flex-grow-1 ${data?.line_data?.length > 5 ? 'max-height-50 mb-20 auto-overflowY hidden-overflowX' : ''}`} >
                                                                                {
                                                                                    orderData?.line_data.map((linedata, j) => (
                                                                                        (payData.skus?.map((sk) => sk === linedata.sku ?
                                                                                            <Fragment key={j}>
                                                                                                <div className='order-info'>
                                                                                                    {orderInfoContent(linedata)}
                                                                                                </div>
                                                                                            </Fragment>
                                                                                            : ''))
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                            <div className='return-dynamic-container '>
                                                                                <div className='return-dynamic-items-wrapper'>
                                                                                    <>
                                                                                        <div className='step-2'>
                                                                                            <div className={`return-item-radio-button-container `}>
                                                                                                <>
                                                                                                    <div className="radio-btn">
                                                                                                        <FormControl>
                                                                                                            <RadioGroup disabled={isSubmitted} className={` ${isSubmitted ? 'op-5 cursor-not-allowed no-pointer-events' : ''}`} value={selectedPayment[index]?.refund_method?.name ? selectedPayment[index]?.refund_method?.name : ""} onChange={(e) => changePayment(e, index, payData?.refund_methods)}
                                                                                                                aria-labelledby="demo-radio-buttons-group-label"
                                                                                                                defaultValue="return label"
                                                                                                                name="radio-buttons-group" sx={{
                                                                                                                    '& .MuiSvgIcon-root': {
                                                                                                                        fontSize: 18,
                                                                                                                    },
                                                                                                                }}>
                                                                                                                {payData?.refund_methods?.map((refundData, j) => {
                                                                                                                    return <div className={`return-item-radio-button-wrapper ${data1?.type}`} key={j}>


                                                                                                                        <FormControlLabel
                                                                                                                            className={`p-3 ${selectedPayment[index]?.refund_method?.name === refundData?.name ? 'bg-darkgrey' : 'bg-lightgrey'}`} value={refundData?.name} control={<Radio disabled={isSubmitted} className={`radio-btn ${data1.type}`} />}
                                                                                                                            label={
                                                                                                                                <Box>
                                                                                                                                    <div className='custom-radio-wrapper'>
                                                                                                                                        <div className='custom-radio'></div>
                                                                                                                                    </div>
                                                                                                                                    <div className={`return-item-radio-button-content ${data1?.type}`}>
                                                                                                                                        <h4>{refundData?.name}</h4>

                                                                                                                                        <div dangerouslySetInnerHTML={{ __html: refundData.description }}></div>

                                                                                                                                        {/* <hr />
                                                                                                                                    <div className='return-amount-container'>
                                                                                                                                        <label>Shipping: <span className={`${refundData?.label_cost?.amount === 0 ? "success-color" : "primary-color"}`}>{refundData.label_cost.currency === 'USD' && refundData.label_cost?.amount !== 0 ? '$' : ''}{refundData.label_cost?.amount === 0 ? 'FREE' : refundData.label_cost?.amount}</span></label>
                                                                                                                                    </div> */}
                                                                                                                                    </div>
                                                                                                                                </Box>
                                                                                                                            }
                                                                                                                        />

                                                                                                                    </div>
                                                                                                                })}
                                                                                                            </RadioGroup>
                                                                                                        </FormControl>
                                                                                                    </div>


                                                                                                </>
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }) : ''}
                                                                </>
                                                            )
                                                                :
                                                                (
                                                                    activeStep === 2 ? (
                                                                        <>
                                                                            {shipmentData && shipmentData.length > 0 ? shipmentData?.map((shipData, index) => {
                                                                                return <div className="order-info-container">
                                                                                    <div className={`order-info-wrapper flex-grow-1 ${data?.line_data?.length > 5 ? 'max-height-50 mb-20 auto-overflowY hidden-overflowX' : ''}`} >
                                                                                        {
                                                                                            orderData?.line_data.map((linedata, j) => (
                                                                                                (shipData.skus?.map((sk) => sk === linedata.sku ?
                                                                                                    <Fragment key={j}>
                                                                                                        <div className='order-info'>
                                                                                                            {orderInfoContent(linedata)}
                                                                                                        </div>
                                                                                                    </Fragment>
                                                                                                    : ''))
                                                                                            ))
                                                                                        }
                                                                                    </div>
                                                                                    <div  className='return-dynamic-container '>
                                                                                        <div className='return-dynamic-items-wrapper'>
                                                                                            <>
                                                                                                <div className='step-2'>
                                                                                                    <div className={`return-item-radio-button-container `}>
                                                                                                        <>
                                                                                                            <div className="radio-btn">
                                                                                                                <FormControl>
                                                                                                                    <RadioGroup disabled={isSubmitted} className={` ${isSubmitted ? 'op-5 cursor-not-allowed no-pointer-events' : ''}`} value={selectedShipment[index]?.return_method?.name ? selectedShipment[index]?.return_method?.name : ""} onChange={(e) => changeShipment(e, index, shipData?.return_location_method_bundle_summary?.return_method_summaries)}
                                                                                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                                                                                        defaultValue="return label"
                                                                                                                        name="radio-buttons-group" sx={{
                                                                                                                            '& .MuiSvgIcon-root': {
                                                                                                                                fontSize: 18,
                                                                                                                            },
                                                                                                                        }}>
                                                                                                                        {shipData?.return_location_method_bundle_summary?.return_method_summaries?.map((methodData, j) => {
                                                                                                                            return <div  className={`return-item-radio-button-wrapper `} key={j}>


                                                                                                                                <FormControlLabel
                                                                                                                                    className={`p-3 ${selectedShipment[index]?.return_method?.name === methodData?.name ? 'bg-darkgrey' : 'bg-lightgrey'}`} value={methodData?.name} control={<Radio disabled={isSubmitted} className={`radio-btn ${data1.type}`} />}
                                                                                                                                    label={
                                                                                                                                        <Box>
                                                                                                                                            <div className='custom-radio-wrapper'>
                                                                                                                                                <div className='custom-radio'></div>
                                                                                                                                            </div>
                                                                                                                                            <div className={`return-item-radio-button-content ${data1?.type}`}>
                                                                                                                                                {methodData?.type === 'HAPPY_RETURNS_BAR_DROP_OFF' ? <div dangerouslySetInnerHTML={{ __html: methodData.name }}></div> : <h4>{methodData?.name}</h4>}

                                                                                                                                                <div ref={containerRef}  dangerouslySetInnerHTML={{ __html:methodData.description}}></div>

                                                                                                                                                <hr />
                                                                                                                                                <div className={`return-amount-container ${data1?.type}`}>
                                                                                                                                                    <label>Shipping: <span className={`${methodData?.label_cost?.amount === 0 ? "success-color" : "primary-color"}`}>{methodData?.label_cost?.currency === 'USD' && methodData.label_cost?.amount !== 0 ? '$' : ''}{methodData.label_cost?.amount === 0 ? 'FREE' : methodData.label_cost?.amount}</span></label>
                                                                                                                                                </div>
                                                                                                                                            </div>
                                                                                                                                        </Box>
                                                                                                                                    }
                                                                                                                                />

                                                                                                                            </div>
                                                                                                                        })}
                                                                                                                    </RadioGroup>
                                                                                                                </FormControl>
                                                                                                            </div>


                                                                                                        </>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            }) : ''}
                                                                        </>
                                                                    )
                                                                        :
                                                                        <div className={`${activeStep === 2 ? 'order-info-container' : ''}`}>
                                                                            <div className={`order-info-wrapper ${data?.line_data?.length > 5 ? 'max-height-50 mb-20 auto-overflowY hidden-overflowX' : ''}`} >
                                                                                {data?.line_data.map((linedata, j) => (
                                                                                    <Fragment key={j}>
                                                                                        <div className='order-info'>
                                                                                            {orderInfoContent(linedata)}
                                                                                        </div>
                                                                                    </Fragment>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                ))
                                                }
                                                <div className='return-item-submit-btn-wrapper'>
                                                    <div className='previous-btn'>
                                                        {
                                                            activeStep !== 0 ? (
                                                                <>
                                                                    <button disabled={activeStep === 3 ? disableReturnBtn : false}
                                                                        className={`fw-500 f-14  ${(activeStep === 3 ? (!disableReturnBtn ? (data1?.type ? data1.type + '-btn' : '') : 'disabled-btn') : data1.type + '-btn')} outlined-btn ${data1?.type}`}
                                                                        onClick={handleBack}
                                                                    >
                                                                        Previous
                                                                    </button>
                                                                </>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <button disabled={activeStep === 0 ? (isValidReasons()) : (activeStep === 1 ? !(paymentData && paymentData.length > 0) : (activeStep === 2 ? !(shipmentData && shipmentData.length > 0) : (activeStep === 3 ? disableReturnBtn : false)))}
                                                        className={`fw-500 f-14 ${activeStep === 0 ? (!isValidReasons() ? (data1?.type ? data1.type + '-btn' : '') : 'disabled-btn') : (activeStep === 1 ? (paymentData && paymentData.length > 0 ? (data1?.type ? data1.type + '-btn' : '') : 'disabled-btn') : activeStep === 2 ? (shipmentData && shipmentData.length > 0 ? (data1?.type ? data1.type + '-btn' : '') : 'disabled-btn') : (activeStep === 3 ? (!disableReturnBtn ? (data1?.type ? data1.type + '-btn' : '') : 'disabled-btn') : data1.type + '-btn'))} ${data1?.type}-btn`}
                                                        onClick={handleNext}>
                                                        {activeStep === 3 ? 'Confirm' : 'Continue'}
                                                    </button>
                                                </div>
                                                <div className='row text-right mr-10 ml-10 mm-x0 d-flex d-md-none'>
                                                    <div className={`${data1.type === 'fluentcommerce' ? 'col-sm-0' : 'col-sm'} col-lg col-md`}></div>
                                                    {data1.type === 'fluentcommerce' ?
                                                        <div className="col-lg-2 col-md-3 col-sm-4">
                                                            <button className={`${data1.type} tertiary-btn full-width mb-16`} title='Extend Pickup Window'> Extend Pickup Window </button>
                                                        </div> : ''}
                                                    {data1.type === 'fluentcommerce' ?
                                                        <div className="col-lg-2 col-md-3 col-sm-4">
                                                            <button className={`${data1.type} tertiary-btn full-width mb-16`} title='Cancel Order'> Cancel Order </button>
                                                        </div> : ''}
                                                </div>
                                            </div> : ''}
                                    </div>
                                    {
                                        (activeStep === 3 && data1.type !== 'janieandjack') ? (
                                            <div className={`card return-order-summary-container ${data1?.type}`}>
                                                <div className='card-header'>
                                                    <h4>Return Order Summary</h4>
                                                </div>
                                                <div className='card-body'>
                                                    <div className='return-order-summary-content'>
                                                        <div>
                                                            <div>
                                                                <label>Return Order Summary:</label>
                                                                <span className='info'>(*Return Subtotal including taxes)</span>
                                                            </div>
                                                            <span>$ {refundData?.refund_summary?.total_refunds?.amount ? refundData?.refund_summary?.total_refunds?.amount : 0}</span>
                                                        </div>
                                                        <div>
                                                            <label>Original Shipping Price</label>
                                                            <span>$ {refundData?.refund_summary?.original_shipping_fee?.amount ? refundData?.refund_summary?.original_shipping_fee?.amount : 0}</span>
                                                        </div>
                                                        <div>
                                                            <label>Total Label Cost: </label>
                                                            <span>$ {refundData?.refund_summary?.total_label_cost?.amount ? refundData?.refund_summary?.total_label_cost?.amount : 0}</span>
                                                        </div>
                                                        <div>
                                                            <label>Total Reward Amount: </label>
                                                            <span>$ 0</span>
                                                        </div>
                                                    </div>
                                                    <div className='return-order-summary-footer'>
                                                        <label>Total Refund Amount: $ {refundData?.refund_summary?.total_refunds?.amount ? refundData?.refund_summary?.total_refunds?.amount : 0}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            // <div className='final-summary-right'>
                                            //                 <div className={`card return-order-summary-container ${data1?.type}`}>
                                            //                     <div className='card-header'>
                                            //                         <h4>Order Summary</h4>
                                            //                     </div>
                                            //                     <div className='card-body'>
                                            //                         <div className={`return-order-summary-content ${data1?.type}`}>
                                            //                             {/* <div className='order-return-type'>
                                            //                                 <h4>FOR EXCHANGE ORDER:</h4>
                                            //                                 <div className='price-list'>
                                            //                                     <label>Exchange Price Adjustment</label>
                                            //                                     <span>- $15.00</span>
                                            //                                 </div>
                                            //                                 <div className='price-list'>
                                            //                                     <label>Exchange Price Refund</label>
                                            //                                     <span>$5.00</span>
                                            //                                 </div>
                                            //                             </div> */}
                                            //                             <div className='order-return-type'>
                                            //                                 <h4>FOR RETURN ORDER:</h4>
                                            //                                 <div className='price-list'>
                                            //                                     <div>
                                            //                                         <label>Return Order Summary:</label>
                                            //                                         <span class="info">(*Return Subtotal including taxes)</span>
                                            //                                     </div>
                                            //                                     <span>$190.00</span>
                                            //                                 </div>
                                            //                                 <div className='price-list'>
                                            //                                     <label>Restocking fee</label>
                                            //                                     <span><span className='deleted-price'>$3.00</span> $0.00</span>
                                            //                                 </div>
                                            //                                 <div className='price-list'>
                                            //                                     <label>Total Label Cost</label>
                                            //                                     <span>- $5.00</span>
                                            //                                 </div>
                                            //                                 <div className='price-list'>
                                            //                                     <label>Reshopping Shipping Fee</label>
                                            //                                     <span>- $3.00</span>
                                            //                                 </div>
                                            //                             </div>
                                            //                         </div>
                                            //                         <div className={`return-order-summary-footer ${data1?.type}`}>
                                            //                                 <label>Total Amount:</label>
                                            //                                 <span>$192.00</span>    
                                            //                         </div>
                                            //                         <div className='credit-refund-box'>
                                            //                             <ul>
                                            //                                 <li>
                                            //                                     <h4>Store Credit</h4>
                                            //                                     <div className='credit-refund-amount'>
                                            //                                         <p>Adding to your store</p>
                                            //                                         <span>$92.00</span>
                                            //                                     </div>
                                            //                                 </li>
                                            //                                 <li>
                                            //                                     <h4>Refunding Amount</h4>
                                            //                                     <div className='credit-refund-amount'>
                                            //                                         <p>Visa **** **** **** 1921</p>
                                            //                                         <span>$100.00</span>
                                            //                                     </div>
                                            //                                 </li>
                                            //                             </ul>
                                            //                         </div>
                                            //                     </div>
                                            //                 </div>
                                            //             </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {confirmingReturn &&
                <div className='loading'>
                    <div className="align-center loader">Confirming Return...</div>
                </div>
            }
            <SimpleDialog
                open={open}
                onClose={dialogClose}
            />
            <Snackbar
                open={snackOpen}
                autoHideDuration={5000}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
            >
                <Alert
                    onClose={handleClose}
                    severity={snackbarProp.style}
                    variant="filled"
                    sx={{ width: '100%' }}
                >{snackbarProp.msg}
                </Alert></Snackbar>
        </div>
    );

}

export default ReturnItem;
